const MINUTE = 60 * 1000;
const HOUR = 60 * MINUTE;
const DAY = 24 * HOUR;

const DAY_FORMAT: Intl.DateTimeFormatOptions = { day: "2-digit", month: "short", year: "numeric" };
const MONTHS = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

export function formatRemaining(ms: number): string {
  if (ms <= 0) return "Window closed";
  if (ms < MINUTE) return "Under a minute left";
  const days = Math.floor(ms / DAY);
  const hours = Math.floor((ms % DAY) / HOUR);
  const minutes = Math.floor((ms % HOUR) / MINUTE);
  if (days > 0) return `${days}d ${hours}h left`;
  if (hours > 0) return `${hours}h ${minutes}m left`;
  return `${minutes}m left`;
}

export function formatDay(iso: string | null | undefined, timeZone?: string): string {
  if (!iso) return "—";
  return new Date(iso).toLocaleDateString("en-IN", { ...DAY_FORMAT, timeZone });
}

export function formatRespondBy(iso: string | null | undefined, timeZone?: string): string {
  if (!iso) return "—";
  return new Date(iso).toLocaleString("en-IN", { ...DAY_FORMAT, hour: "2-digit", minute: "2-digit", hourCycle: "h23", timeZone });
}

export function formatCalendarDate(ymd: string | null | undefined): string {
  if (!ymd) return "—";
  const [year, month, day] = ymd.split("-");
  return `${day} ${MONTHS[Number(month) - 1]} ${year}`;
}

export function formatMonthYear(ym: string | null | undefined): string {
  if (!ym) return "—";
  const [year, month] = ym.split("-");
  return `${MONTHS[Number(month) - 1]} ${year}`;
}
